module.exports = __webpack_public_path__ + "img/Group_22.85e2dc5a.png";